import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokenKey, getMemberKey, getNetworkKey } from '../../utils/keys';
export const useRevokeBadge = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.badge.revoke(input), {
        onMutate: variables => {
            var _a;
            const memberKey = getMemberKey({
                variables: { id: (_a = variables === null || variables === void 0 ? void 0 : variables.input) === null || _a === void 0 ? void 0 : _a.memberId },
            });
            queryClient.cancelQueries(memberKey);
            queryClient.setQueriesData(memberKey, old => ({
                ...old,
                badges: old === null || old === void 0 ? void 0 : old.badges.filter(badge => (badge === null || badge === void 0 ? void 0 : badge.badgeId) !== (variables === null || variables === void 0 ? void 0 : variables.id)),
            }));
        },
        onSettled: (data, error, variables) => {
            var _a;
            const memberKey = getMemberKey({
                variables: { id: (_a = variables === null || variables === void 0 ? void 0 : variables.input) === null || _a === void 0 ? void 0 : _a.memberId },
            });
            const networkKey = getNetworkKey();
            const authTokenKey = getAuthTokenKey();
            queryClient.invalidateQueries(memberKey);
            queryClient.invalidateQueries(authTokenKey);
            queryClient.invalidateQueries(networkKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useRevokeBadge.js.map